// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tAIP","content":"styles_content__2xQiq","tableWrap":"styles_tableWrap__1_WBL"};